export function getAcademicYearLabel(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const startYear = month >= 4 ? year : year - 1;
  const endYear = startYear + 1;
  return `${startYear}-${endYear}`;
}

export function normalizeAcademicYear(value, fallback = getAcademicYearLabel()) {
  if (!value) return fallback;
  const cleaned = String(value).replace(/\s+/g, "");
  if (/^\d{4}-\d{4}$/.test(cleaned)) return cleaned;
  if (/^\d{4}-\d{2}$/.test(cleaned)) {
    const [start, endShort] = cleaned.split("-");
    return `${start}-${start.slice(0, 2)}${endShort}`;
  }
  return cleaned;
}
